import styled from "@emotion/styled"
import { PTableRow } from "@porsche-design-system/components-react"
import { spacingStaticSm } from "@porsche-design-system/components-react/emotion"
import { Skeleton, TableCellFixed } from "src/components"
import { InventoryListTableHead } from "./InventoryListTableHead"
import { inventoryListColumns } from "./inventoryListColumns.const"

interface InventoryListSkeletonProps {
	isCarSalesLiteEnabled: boolean
	isFirstRegistrationDateAvailable: boolean
	rows?: number
}

export const InventoryListSkeleton = ({
	isCarSalesLiteEnabled,
	isFirstRegistrationDateAvailable,
	rows = 50,
}: InventoryListSkeletonProps) => (
	<>
		<Skeleton.Text $width="100px" />
		<Skeleton.Table
			caption="Inventory List"
			compact
			layout="fixed"
			tableHead={
				<InventoryListTableHead
					isCarSalesLiteEnabled={isCarSalesLiteEnabled}
					displayLocation={false}
					isFirstRegistrationDateAvailable={isFirstRegistrationDateAvailable}
				/>
			}
			renderCustomRow={(index) => (
				<PTableRow key={index}>
					<TableCellFixed $width={inventoryListColumns.actionMenu}>
						<Skeleton.ButtonRound />
					</TableCellFixed>
					<TableCellFixed $width={inventoryListColumns.checkbox}>
						<Skeleton.Checkbox compact withLabel={false} />
					</TableCellFixed>
					<TableCellFixed $width={inventoryListColumns.modelName}>
						<ImageColorModelWrapper>
							<Skeleton.Picture $width="75px" />
							<ColorWrapper>
								<Skeleton.ColorTile />
								<Skeleton.ColorTile />
							</ColorWrapper>
							<ColumnWrapper>
								<Skeleton.Text $width="180px" />
								<Skeleton.Text size="xs" $width="100px" />
							</ColumnWrapper>
						</ImageColorModelWrapper>
					</TableCellFixed>
					<TableCellFixed $width={inventoryListColumns.inventoryStatus}>
						<ColumnWrapper>
							<Skeleton.Text $width="180px" />
							<Skeleton.Text size="xs" $width="100px" />
						</ColumnWrapper>
					</TableCellFixed>
					<TableCellFixed $width={inventoryListColumns.salesStatus}>
						<Skeleton.Tag $width="160px" />
					</TableCellFixed>
					<TableCellFixed $width={inventoryListColumns.vehicleType}>
						<Skeleton.Text $width="30px" />
					</TableCellFixed>
					<TableCellFixed
						$width={
							isFirstRegistrationDateAvailable
								? inventoryListColumns.mileageFirstRegistrationDate
								: inventoryListColumns.mileageModelYear
						}
					>
						<ColumnWrapper>
							<Skeleton.Text $width="80px" />
							<Skeleton.Text $width={isFirstRegistrationDateAvailable ? "90px" : "40px"} />
						</ColumnWrapper>
					</TableCellFixed>
					<TableCellFixed $width={inventoryListColumns.price}>
						<ColumnWrapper>
							<Skeleton.Text $width="120px" />
							<Skeleton.Text size="xs" $width="80px" />
						</ColumnWrapper>
					</TableCellFixed>
					<TableCellFixed $width={inventoryListColumns.location}>
						<Skeleton.Text $width="120px" />
					</TableCellFixed>
				</PTableRow>
			)}
			rows={rows}
		/>
	</>
)

const ImageColorModelWrapper = styled.div`
	display: flex;
	align-items: center;
	flex-direction: row;
	gap: ${spacingStaticSm};
	min-width: 0;
`

const ColorWrapper = styled(ImageColorModelWrapper)`
	flex-direction: column;
`

const ColumnWrapper = styled(ColorWrapper)`
	align-items: start;
	gap: 2px;
`
